import React from 'react';
import classNames from 'classnames';
import sprintf from 'yow/sprintf';

import list from '../sandbox-6/list';
import { useBootstrapBreakpoints } from 'react-bootstrap/esm/ThemeProvider';

class List extends React.Component {
	constructor(props) {
		var { log = console.log, sortBy = undefined, selection, selectionStyle, filter = '', sortOrder = undefined, onOrderChange, onFilterChange, onSelectionChange = () => {}, rows, columns, ...otherProps } = props;

		super(props);

		this.log = log;
		this.debug = log;

		this.otherProps = otherProps;

		this.state = {};
		this.state.sortOrder = null;
		this.state.sortBy = null;
		this.state.trash = null;
		this.state.order = null;
		this.state.filter = null;
		this.state.selection = null;
		this.state.key = 0;
		this.state.columns = this.generateColumns(this.props.columns);
		this.state.list = this.generateList({ order: this.state.order, filter: this.state.filter });
	}

	componentDidMount() {}

	onRowClick(index) {
		let selection = {};

		if (Array.isArray(this.state.selection)) {
			this.state.selection.forEach((index) => {
				selection[index] = true;
			});
		}

		switch (this.props.selectionStyle) {
			case 'multiple': {
				if (selection[index]) delete selection[index];
				else selection[index] = true;

				break;
			}
			case 'single': {
				selection[index] = true;
				break;
			}
		}

		selection = Object.keys(selection).map((item) => {
			return parseInt(item);
		});

		this.select(selection);
	}

	onColumnClick(index) {
		let sortOrder = this.state.sortOrder;
		let sortBy = this.state.sortBy;

		if (sortOrder == 'descending' || sortBy != index) {
			sortOrder = 'ascending';
		} else {
			sortOrder = 'descending';
		}

		this.sort({ sortBy: index, sortOrder: sortOrder });
	}

	remove(selection) {
		if (!Array.isArray(selection)) selection = this.state.selection;

		let remove = {};

		if (Array.isArray(selection)) {
			selection.forEach((index) => {
				remove[index] = true;
			});
		}

		let rows = this.props.rows.map((row, index) => {
			if (!remove[index]) return row;
		});

		let order = rows.map((row, index) => {
			return index;
		});

		this.setState({ filter: null, selection: [], order: order }, () => {});
	}

	getSelection() {
		return this.state.selection;
	}

	getSelectedRows() {
		if (!this.state.selection) return [];

		return this.state.selection.map((index) => {
			return this.props.rows[index];
		});
	}

	// Returns an array with indicies of visible rows in the sort order
	getRows() {
		if (!this.state.list) return [];

		return this.state.list.map((index) => {
			return this.props.rows[index];
		});
	}

	getListRows() {
		if (!this.state.list) return [];

		return this.state.list.map((index) => {
			return this.props.rows[index];
		});
	}

	generateColumns(columns) {
		let result = [];

		let formatDate = (value) => {
			if (value == null) {
				return '';
			}
			let date = new Date(value);
			return date.toLocaleDateString();
		};

		let formatDateTime = (value) => {
			if (value == null) {
				return '';
			}
			let date = new Date(value);
			return date.toLocaleString();
		};

		let formatNumber = (value) => {
			if (value == null || value == undefined) {
				return '';
			}

			return value.toLocaleString();
		};

		columns.forEach((column, index) => {
			if (column.text == undefined && typeof column.value == 'function') {
				if (column.type == 'number') {
					if (column.align == undefined) {
						column.align = 'right';
					}
					column.text = (row) => {
						return formatNumber(column.value(row));
					};
				} else if (column.type == 'date') {
					column.text = (row) => {
						return formatDate(column.value(row));
					};
				} else if (column.type == 'datetime') {
					column.text = (row) => {
						return formatDateTime(column.value(row));
					};
				}
			}
			result.push(column);
		});

		return result;
	}

	setColumns(columns) {
		let list = this.generateList({ order: this.state.order, filter: this.state.filter });
		this.setState({ list: list, columns: this.generateColumns(columns), key: this.state.key + 1, sortBy: 0, sortOrder: 'decending' });
	}

	// Returns an array with indicies of visible rows in the sort order
	generateList({ filter, order }) {
		let display = null;
		let list = [];

		if (filter instanceof Array) {
			display = new Map();

			filter.forEach((rowIndex) => {
				display.set(rowIndex, this.props.rows[rowIndex]);
			});
		}

		if (filter instanceof Map) {
			display = filter;
		}

		this.props.rows.forEach((row, rowIndex) => {
			// Translate the row index accordning to sorting
			if (order instanceof Array) {
				rowIndex = order[rowIndex];
			} else if (order instanceof Map) {
				rowIndex = order.get(rowIndex);
			}

			if (!display || display.has(rowIndex)) {
				list.push(rowIndex);
			}
		});

		return list;
	}

	generateFilter({ filter, columns }) {
		if (typeof filter != 'string') return null;

		filter = filter.toUpperCase();

		this.props.columns.forEach((column, index) => {
			if (column.text == undefined && typeof column.value == 'function') {
				column.text = column.value;
			}
		});

		let filterRow = (row) => {
			if (filter == '') return row;

			for (let column of columns) {
				let value = null;

				if (column.text) {
					value = column.text(row);
				} else if (column.value) {
					value = column.value(row);
				}

				if (value != undefined && value != null) {
					let text = value.toString();

					if (text.toUpperCase().includes(filter)) {
						return row;
					}
				}
			}
		};

		let map = new Map();

		this.props.rows.forEach((row, index) => {
			if (filterRow(row)) {
				map.set(index, row);
			}
		});

		return map;
	}

	generateOrder({ sortBy = 0, sortOrder = 'ascending' }) {
		if (this.state.columns[sortBy] == undefined) {
			return null;
		}

		let column = this.state.columns[sortBy];
		let rows = this.props.rows;

		let order = this.props.rows.map((row, rowIndex) => {
			return rowIndex;
		});

		let compare = (a, b) => {
			let valueA = column.value(rows[a]);
			let valueB = column.value(rows[b]);

			if (valueA == null) {
				return valueB == null ? 0 : 1;
			}
			if (valueB == null) {
				return valueA == null ? 0 : -1;
			}


            if (valueA < valueB) {
				return 1;
			}
			if (valueA > valueB) {
				return -1;
			}
			return 0;
		};

		if (sortOrder == 'descending') {
			order = order.sort((a, b) => {
				return compare(a, b);
			});
		} else {
			order = order.sort((a, b) => {
				return compare(b, a);
			});
		}

		let map = new Map();

		order.forEach((item, index) => {
			map.set(index, item);
		});

		return map;
	}

	sort({ sortBy = 0, sortOrder = 'ascending' }) {
		if (this.state.columns[sortBy] != undefined) {
			let column = this.state.columns[sortBy];

			if (column.value) {
				let state = {};
				state.order = this.generateOrder({ sortBy: sortBy, sortOrder: sortOrder });
				state.list = this.generateList({ order: state.order, filter: this.state.filter });
				state.sortBy = sortBy;
				state.sortOrder = sortOrder;

				this.setState(state, () => {
					if (typeof this.props.onOrderChange == 'function') {
						this.props.onOrderChange(state.order);
					}
					if (typeof this.props.onListChange == 'function') {
						this.props.onListChange(state.list);
					}
				});
			}
		}
	}

	filter(filter) {
		let state = {};
		state.filter = this.generateFilter({ filter: filter, columns: this.state.columns });
		state.list = this.generateList({ filter: state.filter, order: this.state.order });

		this.setState(state, () => {
			if (typeof this.props.onFilterChange == 'function') {
				this.props.onFilterChange(filter, state.filter);
			}
			if (typeof this.props.onListChange == 'function') {
				this.props.onListChange(state.list);
			}
		});
	}

	trash(selection) {}

	getTrash() {
		return this.state.trash;
	}

	getFilter() {
		return this.state.filter;
	}

	select(selection) {
		if (!Array.isArray(selection)) selection = [];

		this.setState({ selection: selection }, () => {
			if (typeof this.props.onSelectionChange == 'function') {
				this.props.onSelectionChange(selection);
			}
		});
	}

	render() {
		return (
			<div {...this.otherProps} key={this.state.key}>
				<List.Table>
					<List.Header>
						<List.Columns onColumnClick={this.onColumnClick.bind(this)} columns={this.state.columns} sortOrder={this.state.sortOrder} sortBy={this.state.sortBy}></List.Columns>
					</List.Header>
					<List.Body>
						<List.Rows onRowClick={this.onRowClick.bind(this)} list={this.state.list} selection={this.state.selection} rows={this.props.rows} columns={this.state.columns}></List.Rows>
					</List.Body>
				</List.Table>
			</div>
		);
	}
}

List.Table = function (props) {
	var { rows, columns, className, style = {}, ...props } = props;

	style.cursor = 'default';
	className = classNames(className, 'table table-hover');

	return <table className={className} style={style} {...props}></table>;
};

List.Header = function (props) {
	var { style = {}, ...props } = props;

	style.position = 'sticky';
	style.top = 0;

	return <thead style={style} {...props} />;
};

List.Columns = function (props) {
	var { columns, onColumnClick, sortBy, sortOrder, ...props } = props;

	props.style = { fontSize: '90%' };
	props.style.background = 'var(--bs-light)';

	let children = columns.map((column, columnIndex) => {
		return <List.Column key={columnIndex} onColumnClick={onColumnClick} column={column} sortBy={sortBy} sortOrder={sortOrder} columnIndex={columnIndex} />;
	});

	return <tr {...props}>{children}</tr>;
};

List.Column = function (props) {
	var { column, rows, columnIndex, onColumnClick = () => {}, sortBy, sortOrder, ...props } = props;

	let descendingSymbol = '▲';
	let ascendingSymbol = '▼';
	let align = column.align || 'left';
	let sort = sortBy == columnIndex ? sortOrder : undefined;

	props.key = columnIndex;
	props.className = '';
	props.style = { ...column.style };

	props.onClick = (event) => {
		onColumnClick(columnIndex);
	};

	switch (align) {
		case 'left':
			props.className = classNames(props.className, 'text-start');
			break;
		case 'right':
			props.className = classNames(props.className, 'text-end');
			break;
		case 'center':
			props.className = classNames(props.className, 'text-center');
			break;
	}

	let renderSortSymbol = (sort) => {
		let symbol = '';
		let className = 'align-middle px-1';
		let style = { fontSize: '75%' };

		switch (sort) {
			case 'ascending': {
				symbol = '▲';
				break;
			}

			case 'descending': {
				symbol = '▼';
				break;
			}

			// Use opacity 0 with same symbol to keep column widths the same
			default: {
				symbol = '▲';
				style.opacity = 0;
				break;
			}
		}

		return (
			<span style={style} className={className}>
				{symbol}
			</span>
		);
	};

	let renderTitle = () => {
		let html;

		switch (align) {
			case 'left': {
				html = (
					<>
						{column.name}
						{renderSortSymbol(sort)}
					</>
				);
				break;
			}
			case 'right': {
				html = (
					<>
						{renderSortSymbol(sort)}
						{column.name}
					</>
				);
				break;
			}

			default: {
				html = (
					<>
						{renderSortSymbol()}
						{column.name}
						{renderSortSymbol(sort)}
					</>
				);
				break;
			}
		}

		return html;
	};
	return <th {...props}>{renderTitle()}</th>;
};

List.Body = function (props) {
	return <tbody {...props} />;
};

List.Rows = function (props) {
	var { columns, onRowClick = () => {}, selection = null, rows, list, ...props } = props;

	let selected = new Map();

	if (Array.isArray(selection)) {
		selection.forEach((rowIndex) => {
			selected.set(rowIndex, true);
		});
	}

	let html = list.map((rowIndex) => {
		let row = rows[rowIndex];
		let className = null;

		let onClick = (event) => {
			onRowClick(rowIndex);
		};

		if (selected.has(rowIndex)) className = 'table-primary';

		return <List.Row columns={columns} key={rowIndex} row={row} rowIndex={rowIndex} onClick={onClick} className={className} />;
	});

	return <>{html}</>;
};

List.Row = function (props) {
	var { columns, onRowClick = () => {}, rowIndex, row, ...props } = props;

	let children = columns.map((column, columnIndex) => {
		return <List.Cell key={columnIndex} row={row} column={column} rowIndex={rowIndex} columnIndex={columnIndex} />;
	});

	return <tr {...props}>{children}</tr>;
};

List.Cell = function (props) {
	var { rowIndex, columnIndex, content = undefined, row, column, ...props } = props;

	props.key = columnIndex;

	if (content == undefined) {
		content = column.content;
	}

	if (content == undefined) {
		content = column.text;
	}

	if (content == undefined) {
		content = column.value;
	}

	if (typeof content == 'function') {
		content = content(row, rowIndex, columnIndex);
	}

	switch (column.align) {
		case 'left':
			props.className = classNames(props.className, 'text-start');
			break;
		case 'right':
			props.className = classNames(props.className, 'text-end');
			break;
		case 'center':
			props.className = classNames(props.className, 'text-center');
			break;
	}

	return <td {...props}>{content}</td>;
};

export default List;
